import { render } from "./HpBanner.vue?vue&type=template&id=765cc755"
import script from "./HpBanner.vue?vue&type=script&lang=js"
export * from "./HpBanner.vue?vue&type=script&lang=js"

import "./HpBanner.vue?vue&type=style&index=0&id=765cc755&lang=scss"

import exportComponent from "/home/rubb/NiwCaetano/Frontend/governance/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__